import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n/translations";
import { SERVICES } from "../data/mock";
import { getIcon } from "../lib/icons";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";

const Services = () => {
  const { lang } = useLanguage();
  const t = translations[lang].servicesPage;

  return (
    <>
      <Seo
        title={t.hero}
        description={t.heroDesc}
        path="/hizmetlerimiz"
        lang={lang}
      />
      <PageHero title={t.hero} desc={t.heroDesc} />

      <section className="bg-white py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 space-y-8">
          {SERVICES.map((s, i) => {
            const Icon = getIcon(s.icon);
            const reverse = i % 2 === 1;
            return (
              <Reveal key={s.id}>
                <div
                  id={s.slug}
                  className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center rounded-3xl border border-slate-200 p-6 lg:p-10 hover:shadow-xl transition-shadow"
                >
                  <div className={reverse ? "lg:order-2" : ""}>
                    <div className="relative rounded-2xl overflow-hidden">
                      <img
                        src={s.image}
                        alt={s.title[lang]}
                        className="w-full h-[300px] object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-navy-950/60 to-transparent" />
                      <span className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-lg bg-white/90 backdrop-blur px-3 py-2 text-sm font-semibold text-navy-900">
                        <Icon className="w-5 h-5 text-amber-500" />
                        {s.tag[lang]}
                      </span>
                    </div>
                  </div>
                  <div className={reverse ? "lg:order-1" : ""}>
                    <span className="text-xs font-semibold uppercase tracking-wider text-amber-500">
                      {s.number} — {s.tag[lang]}
                    </span>
                    <h2 className="mt-2 font-display font-bold text-2xl lg:text-3xl text-navy-900">
                      {s.title[lang]}
                    </h2>
                    <p className="mt-4 text-slate-600 leading-relaxed">{s.short[lang]}</p>
                    <div className="mt-6">
                      <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                        {t.includes}
                      </span>
                      <ul className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
                        {s.features[lang].map((f) => (
                          <li key={f} className="flex items-start gap-2.5">
                            <Check className="w-4 h-4 text-amber-500 mt-1 shrink-0" />
                            <span className="text-slate-700 text-sm">{f}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <Link
                      to={`/hizmetlerimiz/${s.slug}`}
                      className="mt-6 inline-flex items-center gap-2 text-navy-900 font-semibold hover:text-amber-600 hover:gap-3 transition-all"
                    >
                      {translations[lang].servicesOverview.learnMore}
                      <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-slate-50 py-16">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <h2 className="font-display font-bold text-2xl lg:text-3xl text-navy-900">
            {t.ctaTitle}
          </h2>
          <p className="mt-4 text-slate-600 text-lg">{t.ctaDesc}</p>
          <Link
            to="/iletisim"
            className="mt-8 inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-navy-950 font-semibold px-8 py-4 rounded-xl transition-colors shadow-lg shadow-amber-500/20"
          >
            {translations[lang].ctaBanner.button}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default Services;
